import React from 'react';
import ErrorBoundary from '../../../../components/ErrorBoundary';
import HelpButton from '../../../../components/HelpButton';
import PbxVirtualOperator from './PbxVirtualOperator';
import TicketsFieldsTree from '../../Tickets/TicketsFieldsTree';
import { TicketEnums } from '../../../../js/tickets/TicketUtils';

const PbxVirtualOperatorCallQuestionsPage = (props) => (
  <PbxVirtualOperator scrolling>
    <div className="text-right">
      <HelpButton fileName="virtual-operator-call-questions" />
    </div>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        <TicketsFieldsTree scope={TicketEnums.TicketScope.ASSISTANT} {...props} />
      </React.Suspense>
    </ErrorBoundary>
  </PbxVirtualOperator>
);

export default PbxVirtualOperatorCallQuestionsPage;
